import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { MESSAGE_TYPE } from 'widget/helpers/constants';

export const CONTROL_ROOM_REMINDER_THRESHOLDS = {
  WATCH: 60,
  WARNING: 180,
  CRITICAL: 300,
};

export const getControlRoomReminderElapsedSeconds = ({
  startedAt,
  now = Date.now(),
}) => {
  const elapsedMs = now - startedAt;
  return Math.max(0, Math.floor(elapsedMs / 1000));
};

export const getControlRoomReminderSeverity = elapsedSeconds => {
  if (elapsedSeconds >= CONTROL_ROOM_REMINDER_THRESHOLDS.CRITICAL) {
    return 'critical';
  }

  if (elapsedSeconds >= CONTROL_ROOM_REMINDER_THRESHOLDS.WARNING) {
    return 'warning';
  }

  if (elapsedSeconds >= CONTROL_ROOM_REMINDER_THRESHOLDS.WATCH) {
    return 'watch';
  }

  return 'notice';
};

export const isControlRoomReminderCritical = elapsedSeconds =>
  getControlRoomReminderSeverity(elapsedSeconds) === 'critical';

export const getLatestIncomingMessageId = (messages = []) => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message.message_type === MESSAGE_TYPE.INCOMING) {
      return message.id;
    }
  }

  return null;
};

export const isControlRoomReminderMuted = ({
  mutedMessageId,
  latestIncomingMessageId,
}) => {
  if (!mutedMessageId || !latestIncomingMessageId) {
    return false;
  }

  return Number(mutedMessageId) === Number(latestIncomingMessageId);
};

export const shouldShowControlRoomReminder = ({
  enabled,
  hasBaseUrl,
  isMuted,
}) => enabled && hasBaseUrl && !isMuted;

export const getControlRoomReminderMutedMessageId = conversationId =>
  LocalStorage.getFromJsonStore(
    LOCAL_STORAGE_KEYS.CONTROL_ROOM_REMINDER_MUTED_MESSAGE_ID,
    conversationId
  );

export const setControlRoomReminderMutedMessageId = (
  conversationId,
  messageId
) => {
  LocalStorage.updateJsonStore(
    LOCAL_STORAGE_KEYS.CONTROL_ROOM_REMINDER_MUTED_MESSAGE_ID,
    conversationId,
    messageId
  );
};

export const loadControlRoomReminderStartedAt = (
  conversationId,
  now = Date.now()
) => {
  const storedStartedAt = LocalStorage.getFromJsonStore(
    LOCAL_STORAGE_KEYS.CONTROL_ROOM_REMINDER_STARTED_AT,
    conversationId
  );

  if (storedStartedAt) {
    return Number(storedStartedAt);
  }

  LocalStorage.updateJsonStore(
    LOCAL_STORAGE_KEYS.CONTROL_ROOM_REMINDER_STARTED_AT,
    conversationId,
    now
  );

  return now;
};

export const clearControlRoomReminderStartedAt = conversationId => {
  LocalStorage.deleteFromJsonStore(
    LOCAL_STORAGE_KEYS.CONTROL_ROOM_REMINDER_STARTED_AT,
    conversationId
  );
};
